import { render } from "./FaceEndMessage.vue?vue&type=template&id=dd956592&scoped=true"
import script from "./FaceEndMessage.vue?vue&type=script&lang=js"
export * from "./FaceEndMessage.vue?vue&type=script&lang=js"

import "./FaceEndMessage.vue?vue&type=style&index=0&id=dd956592&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-dd956592"

export default script